import { useEffect, useRef } from 'react';
import './context'; // RD: starts telling the RD app what is open
import { isRdEmbedded } from './embedded';

/**
 * Reflective Data: when Lightdash is framed by the RD app it follows the app's light/dark choice. The app is another origin,
 * so it can't be read directly: we ask the parent window for the theme on load, and it also tells us when the choice changes.
 * Only messages from the parent window are accepted, and the only thing a message can do is switch light/dark.
 */
export const useRdColorScheme = (setColorScheme: (scheme: 'light' | 'dark') => void) => {
    const set = useRef(setColorScheme);
    set.current = setColorScheme;
    useEffect(() => {
        if (!isRdEmbedded) return undefined;
        const onMessage = (e: MessageEvent) => {
            if (e.source !== window.parent) return;
            const theme = e.data?.type === 'rd-theme' ? e.data.theme : undefined;
            if (theme === 'light' || theme === 'dark') set.current(theme);
        };
        window.addEventListener('message', onMessage);
        window.parent.postMessage({ type: 'rd-theme-request' }, '*');
        return () => window.removeEventListener('message', onMessage);
    }, []);
};
